import { intialDataToLocalStorage } from "../data.js";

// Utilisation de la fonction pour obtenir une date avec 3 minutes d'avance
export function getISODateWithAdvance(minutes) {
  // Obtenez la date et l'heure actuelles
  const currentDate = new Date();

  // Ajoutez le nombre de minutes spécifié à la date actuelle
  currentDate.setMinutes(currentDate.getMinutes() + minutes);

  // Convertissez la date en format ISO et retournez-la
  return currentDate.toISOString();
}

export function handleDataStructure(page, value) {
  // Récupérez les données du localStorage
  const storedData = JSON.parse(localStorage.getItem("kaba_info")) || {};

  // Initialisez les données avec les données stockées ou par défaut
  let kaba_info = intialDataToLocalStorage.kaba_info;

  const data = {
    kaba_info,
    ...storedData, // Fusionnez les données stockées avec les données par défaut
  };

  // Mettez à jour le champ spécifié en le définissant à la valeur fournie
  switch (page) {
    case "signin":
      data.kaba_info.login.signin = true;
      data.kaba_info.login.verification = false;
      data.kaba_info.login.signup = false;
      data.kaba_info.login.oups = false;
      data.kaba_info.ticket.ticket = false;

      break;
    case "verification":
      data.kaba_info.login.signin = false;
      data.kaba_info.login.verification = true;
      data.kaba_info.login.signup = false;
      data.kaba_info.login.oups = false;
      data.kaba_info.ticket.ticket = false;

      break;
    case "signup":
      data.kaba_info.login.signin = false;
      data.kaba_info.login.verification = false;
      data.kaba_info.login.signup = true;
      data.kaba_info.login.oups = false;
      data.kaba_info.ticket.ticket = false;

      break;
    case "oups":
      data.kaba_info.login.signin = false;
      data.kaba_info.login.verification = false;
      data.kaba_info.login.signup = false;
      data.kaba_info.login.oups = true;
      data.kaba_info.ticket.ticket = false;

      break;
    case "ticket":
      data.kaba_info.login.signin = false;
      data.kaba_info.login.verification = false;
      data.kaba_info.login.signup = false;
      data.kaba_info.login.oups = false;
      data.kaba_info.ticket.ticket = true;
      break;
    case "one_time_password_id":
      data.kaba_info.one_time_password.one_time_password_id = value || "";
      break;
    case "one_time_passoword_type":
      data.kaba_info.one_time_password.one_time_passoword_type = value || "";
      break;
    case "one_time_password":
      data.kaba_info.one_time_password.one_time_password = value || "";
      break;
    case "one_time_password_quota_day":
      data.kaba_info.one_time_password.one_time_password_quota_day =
        value || 10;
      break;
    case "neguediourou":
      // Mettez à jour 'neguediourou'
      data.kaba_info.neguediourou = value || "";
      break;
    case "phone":
      // Mettez à jour 'neguediourou'
      data.kaba_info.phone = value || "";
      break;
    case "kabakoo.africa.token":
      // Mettez à jour 'kabakoo.africa.token'
      data.kaba_info["kabakoo.africa.token"] = value || "";
      break;
    case "source":
      // Mettez à jour 'source'
      data.kaba_info.source = value || "https://app.kabakoo.africa";
      break;
    case "time":
      // Mettez à jour 'time'
      data.kaba_info.time = value || "2023-09-05T17:57:30.973Z";
      break;
    case "help":
      data.kaba_info.help = value;
      break;
    case "device_id":
      // Mettez à jour 'device_id'
      data.kaba_info.device_id = value || "";
      break;
    case "ticket.data":
      // Ici on vide le tableau
      data.kaba_info.ticket.data = [];

      Object.entries(value).forEach(([key, value]) => {
        data.kaba_info.ticket.data.push({ key, value });
      });

      break;
    default:
      console.error("Champ non reconnu");
      return;
  }

  // Enregistrez les données mises à jour dans le localStorage
  localStorage.setItem("kaba_info", JSON.stringify(data));
  // window.location.reload();
}

export function getLocalStorageData() {
  // Convertissez l'objet en chaîne JSON
  let get_local_data =
    JSON.parse(localStorage.getItem("kaba_info")) || intialDataToLocalStorage;

  return get_local_data;
}

export function getSourceInAnAddressBar() {
  // Récupérez le fragment (tout ce qui vient après "#") de la barre d'adresse
  const fragment = window.location.hash;

  // Retirez le "#" initial si nécessaire
  const cleanedFragment = fragment.startsWith("#")
    ? fragment.slice(1)
    : fragment;

  // Supprimez le mot "origin=" du fragment
  const withoutOrigin = cleanedFragment.replace(/^origin=/, "");

  // Utilisez withoutOrigin comme bon vous semble

  withoutOrigin ? handleDataStructure("source", withoutOrigin) : "";
}

export function getDeviceIdFromURL() {
  // Récupérez les paramètres de l'URL
  const urlParams = new URLSearchParams(window.location.search);

  // Obtenez le paramètre device-id
  const deviceId = urlParams.get('device-id');

  // Si le device-id existe, stockez-le dans le localStorage
  if (deviceId) {
    handleDataStructure("device_id", deviceId);
  }
}

export function urlConfiguration(phone_encrypt, token, lien) {
  // L'URL de base
  let baseUrl = isURL(lien) ? lien : "https://app.kabakoo.africa";

  // Les paramètres que vous souhaitez ajouter
  const params = {
    neguediourou: phone_encrypt,
    token: token,
  };

  // Vérifiez si l'URL de base contient déjà un point d'interrogation
  if (baseUrl.includes("?")) {
    // Si oui, ajoutez simplement les paramètres
    baseUrl += `&${new URLSearchParams(params).toString()}`;
  } else {
    // Sinon, ajoutez "?" suivi des paramètres
    baseUrl += `?${new URLSearchParams(params).toString()}`;
  }
  return baseUrl;
}

function isURL(string) {
  // Expression régulière pour valider une URL
  const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
  return urlRegex.test(string);
}

export function validatePhoneNumber(phoneNumber) {
  // Supprimez tous les espaces
  const cleanedPhoneNumber = phoneNumber.replace(/\s/g, "");

  // Validez que le numéro ne commence pas par 0, contient que des chiffres, et a au moins 8 chiffres
  const isValidPhoneNumber = /^[1-9]\d{7,}$/.test(cleanedPhoneNumber);

  return isValidPhoneNumber;
}

export function checkInputLength(input) {
  return input.length > 1;
}
export function currentYear() {
  let dateActuelle = new Date();
  let anneeActuelle = dateActuelle.getFullYear();
  return anneeActuelle.toString();
}